import { gql } from '@apollo/client';

export const GET_CHATBOT_SECTIONS_LIST = gql`
  query ChatbotSections($params: FindChatbotSectionListInput!) {
    chatbotSections(params: $params) {
      success
      message
      errors
      data {
        sections {
          id
          code
          name
          description
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_CHATBOT_SECTION = gql`
  query ChatbotSection($params: FindChatbotSectionInput!) {
    chatbotSection(params: $params) {
      success
      message
      errors
      data {
        id
        code
        name
        description
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
